import { useEffect, useState } from 'react';
import { SelectLogmar, LogmarTest, AcuityResults } from '..';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { ExamBody, useExamStep } from '../exams/common';

const Logmar = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeSetup');
  const logmarType = testData.testKey.startsWith('open') ? 'Open' : 'Crowded';
  const postMessage = usePostMessage();
  useExamStep(testData.testKey, step);

  useEffect(() => {
    const testTitle = `${logmarType} logMAR Test`;
    switch (step) {
      case 'eyeSetup':
        setTitle(`${testTitle}`);
        break;
      case 'rightEyeSetup':
        setTitle(`${testTitle} - Right Eye`);
        break;
      case 'leftEyeSetup':
        setTitle(`${testTitle} - Left Eye`);
        if (testData.testRightEye) updateTestData({ testInProgress: true });
        break;
      case 'bothEyesSetup':
        setTitle(`${testTitle} - Binocular`);
        break;
      case 'rightEyeTest':
        setTitle(`${testTitle} - Right Eye`);
        break;
      case 'leftEyeTest':
        setTitle(`${testTitle} - Left Eye`);
        break;
      case 'bothEyesTest':
        setTitle(`${testTitle} - Binocular`);
        break;
      case 'results':
        setTitle(`${testTitle} Results`);
        break;
      default:
        break;
    }
  }, [logmarType, updateTestData, step, testData.testRightEye, setTitle]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') postMessage({ type: 'endOfTest' });
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    return setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} selectLetters />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <SelectLogmar eyeTested={step.split('S')[0]} displayCharacters updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <LogmarTest logmarType={logmarType} eyeTested={step.split('T')[0]} updateStep={updateStep} />;
      case 'results':
        return <AcuityResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return <ExamBody>{renderSwitch()}</ExamBody>;
};

export default Logmar;
